/* eslint-disable @next/next/no-img-element */
import Head from 'next/head'
import Link from 'next/link'
import { Parallax } from 'react-parallax'
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function DeveloperLibraries() {
    return (
        <div>
            <Head>
                <title>Lindle Developer Libraries</title>
                <meta name="description" content="Developer libraries that can used to add functionality to 3rd party apps" />
                <link rel="icon" href="/favicon.ico" />

                {/* Facebook */}
                <meta property="og:title" content="Lindle" />
                <meta property="og:description" content="Developer libraries that can used to add functionality to 3rd party apps" />
                <meta property="og:image" content="/logoText.png" />
                <meta property="og:url" content="https://lindle.vercel.app" />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content="Lindle" />
                <meta name="twitter:description" content="Developer libraries that can used to add functionality to 3rd party apps" />
                <meta name="twitter:image" content="/logoText.png" />
                <meta name="twitter:card" content="/bannerText.png" />

                {/* pinterest */}
                <meta name="pinterest-rich-pin" content="true" />
            </Head>


            {/* Navigation */}
            <Navigation />

            <Parallax bgImage="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" bgImageStyle={{ filter: "brightness(0.3)", width: "100%", height: 'fit-content' }} bgImageAlt="Programmers" strength={400}>
                <section className='mobile:p-5 tablet:p-16 text-3xl text-white text-center'>
                    <h2 className='mobile:text-3xl tablet:text-8xl my-6'><b>Developer Libraries</b></h2>
                    <p>Welcome to Lindle&apos;s developer hub! Simplify link management and organization in your apps with Lindle libraries available for npm, Flutter, PHP, and Python.</p>
                </section>

            </Parallax>


            <main className='mobile:w-full tablet:w-1/2 justify-end self-center mx-auto px-6'>
                <section>

                    <div className='flex my-5 items-center rounded-xl border-2 border-gray-600 px-3 duration-500 hover:bg-slate-50'>
                        <img width="96" height="96" src="https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/96/external-npm-a-package-manager-for-the-javascript-programming-language-logo-shadow-tal-revivo.png" alt="external-npm-a-package-manager-for-the-javascript-programming-language-logo-shadow-tal-revivo" />
                        <div className='w-full'></div>
                        <Link target='_blank' className='bg-red-300 px-5 py-3 rounded-md shadow-lg shadow-red-400 hover:shadow-red-600 duration-500 hover:bg-red-500 hover:text-white text-lg' href="https://www.npmjs.com/package/lindle">USE</Link>
                    </div>

                    <div className='flex my-5 items-center rounded-xl border-2 border-gray-600 px-3 duration-500 hover:bg-slate-50'>
                        <img width="96" height="96" src="https://img.icons8.com/color/96/flutter.png" alt="flutter" />
                        <div className='w-full'></div>
                        <Link target='_blank' className='bg-blue-300 px-5 py-3 rounded-md shadow-lg shadow-blue-400 hover:shadow-blue-600 duration-500 hover:bg-blue-500 hover:text-white text-lg' href="https://pub.dev/packages/lindle">USE</Link>
                    </div>

                    <div className='flex my-5 items-center rounded-xl border-2 border-gray-600 px-3 duration-500 hover:bg-slate-50'>
                        <img width="96" height="96" src="https://img.icons8.com/fluency/96/python.png" alt="python" />
                        <div className='w-full'></div>
                        <Link target='_blank' className='bg-amber-300 px-5 py-3 rounded-md shadow-lg shadow-amber-400 hover:shadow-amber-600 duration-500 hover:bg-amber-500 hover:text-white text-lg' href="https://pypi.org/project/lindle/">USE</Link>
                    </div>

                    <div className='flex my-5 items-center rounded-xl border-2 border-gray-600 px-3 duration-500 hover:bg-slate-50'>
                        <img width="96" height="96" src="https://img.icons8.com/external-those-icons-flat-those-icons/96/external-PHP-programming-and-development-those-icons-flat-those-icons.png" alt="external-PHP-programming-and-development-those-icons-flat-those-icons" />
                        <div className='w-full'></div>
                        <Link target='_blank' className='bg-purple-300 px-5 py-3 rounded-md shadow-lg shadow-purple-400 hover:shadow-purple-600 duration-500 hover:bg-purple-500 hover:text-white text-lg' href="https://packagist.org/packages/m2kdevelopments/lindle">USE</Link>
                    </div>


                </section>
            </main>

            <Footer />
        </div>
    )
}

export default DeveloperLibraries